"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyContainerContext = void 0;
var React = __importStar(require("react"));
var DependencyContainerReactContext_1 = require("./DependencyContainerReactContext");
var dependency_injection_1 = require("@meraki-internal/dependency-injection");
var GlobalIOCHelper = /** @class */ (function () {
    function GlobalIOCHelper(root) {
        var _this = this;
        this.root = root;
        this.get = function (name) {
            return _this.root.getByStringName(name);
        };
        this.getAtElelement = function (el, name) {
            var container = el.container;
            while (!container) {
                el = el.parentNode;
                if (!el) {
                    throw new Error('failed to find a container from the provided el and its parents');
                }
                container = el.container;
            }
            return container.getByStringName(name);
        };
        window.IOC = this;
    }
    return GlobalIOCHelper;
}());
var DependencyContainerContext = /** @class */ (function (_super) {
    __extends(DependencyContainerContext, _super);
    function DependencyContainerContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setContainerOnElement = function (el) {
            if (!el) {
                console.error('Unable to set container on undefined element');
                return;
            }
            el.container = _this.container;
        };
        _this.state = {
            doneInjecting: false,
        };
        return _this;
    }
    DependencyContainerContext.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If you didn't provide your own container and you didn't implement containerMounted
                        // then you are just creating an empty child container, which is likely a mistake
                        if (!this.props.container && !this.containerMounted) {
                            throw new Error(this.constructor.name + ' must implement containerMounted');
                        }
                        // Use the provided container
                        if (this.props.container) {
                            this.container = this.props.container;
                            // Otherwise create a child container
                        }
                        else if (this.context.container) {
                            this.container = this.context.container.createChild();
                            // Otherwise create a new top-level container
                        }
                        else {
                            this.container = new dependency_injection_1.Container();
                            new GlobalIOCHelper(this.container);
                        }
                        if (!this.containerMounted) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.containerMounted(this.container)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setState({ doneInjecting: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    DependencyContainerContext.prototype.componentWillUnmount = function () {
        this.container.dispose();
    };
    DependencyContainerContext.prototype.render = function () {
        var doneInjecting = this.state.doneInjecting;
        var children = this.props.children;
        if (!doneInjecting) {
            return this.renderLoading();
        }
        return (React.createElement("div", { "data-container": true, ref: this.setContainerOnElement },
            React.createElement(DependencyContainerReactContext_1.DependencyContainerReactContext.Provider, { value: { container: this.container } }, children)));
    };
    DependencyContainerContext.prototype.renderLoading = function () {
        return null;
    };
    DependencyContainerContext.contextType = DependencyContainerReactContext_1.DependencyContainerReactContext;
    return DependencyContainerContext;
}(React.Component));
exports.DependencyContainerContext = DependencyContainerContext;
//# sourceMappingURL=DependencyContainerContext.js.map